<template>
    <section class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12 col-sm-6 col-md-4 d-flex align-items-stretch flex-column">
                    <div class="card bg-light d-flex flex-fill">
                        <div class="card-header text-muted border-bottom-0">
                        Daftar Try Out Event
                        </div>
                        <div class="card-body pt-0">
                        <div class="row">
                            <div class="col-12">
                            <h2 class="lead"><b>{{ ujian.nama_paket }}</b></h2>
                            </div>
                        </div>
                        </div>
                        <div class="card-footer">
                        <div class="text-right">
                    		<router-link :to='tipe_ujian == "ujian" ? "/ujian-event" : "/soal-mapel"' class="btn btn-sm btn-secondary">
                            <i class="fas fa-arrow-left"></i> Ke Halaman Pilih Paket Try Out
                    		</router-link>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
            <br>
			<table class="table table-hover" ref="tblujian">
			<thead>
				<tr>
				<th>TRY OUT</th>
                <th>DURASI</th>
                <th>JUMLAH SOAL</th>
                <th>PENGERJAAN</th>
                <th>TINDAKAN</th>
				</tr>
			</thead>
			<tbody @click="handleClick"></tbody>
			</table>
        </div>
    </section>
</template>
<script>
	import { createTable, authFetch } from "@/libs/hxcore";
    export default {
    name: 'UjianEventList',
    data: () => ({
      ujian: {},
	  roles: "",
	  tipe_ujian: '',
    }),
    created: function () {
        let id = this.$route.params.id;
		this.tipe_ujian = this.$route.params.type;
        if (this.tipe_ujian == 'latihan') {
            this.loadMapel(id);
        } else {
            this.loadPaket(id);
        }

		this.roles = this.$route.meta.roles;
    	console.log("load initial data", this.$route);
    },
    methods: {
        loadMapel(id){
			authFetch("/siswa/ujian/latihan_list_event/" + id).then((res) => {
				res.json().then((json) => {
				this.ujian = json;
				});
			});
        },
        loadPaket(id){
			authFetch("/siswa/ujian/list_event/" + id).then((res) => {
				res.json().then((json) => {
				this.ujian = json;
				});
			});
        },
		handleClick(e) {
			if (e.target.matches(".link-role")) {
				this.$router.push({ path: "/permit/" + e.target.dataset.id });
				return false;
			}

			if (e.target.matches(".btn-warning")) {
				if (e.target.dataset.action == "continue") {
					this.$router.push("/ujian-process-simbol/" + e.target.dataset.id);
				}
			}

			if (e.target.matches(".btn-info")) {
				if (e.target.dataset.action == "view") {
					this.$router.push("/ujian-start/" + e.target.dataset.id);
				}
			}

			if (e.target.matches(".btn-success")) {
				if (e.target.dataset.action == "view") {
					this.$router.push("/ujian-finish/" + e.target.dataset.id)
				}

				if (e.target.dataset.action == "rekap-kecermatan") {
					this.$router.push({path: '/rekap-hasil-kecermatan', query: {ujian_code: e.target.dataset.id}})
				}

				if (e.target.dataset.action == "rekap-simbol") {
					this.$router.push({path: '/rekap-hasil-simbol-aritmatika', query: {ujian_code: e.target.dataset.id}})
				}
			}

			if (e.target.matches(".btn-primary")) {
				if (e.target.dataset.action == "rank") {
					// ujian/ranking/mapel_id/code
					this.$router.push("/ujian/ranking/"+ e.target.dataset.mapelid +"/" + e.target.dataset.id);
				}
			}
		},
    },
    mounted(){
	const e = this.$refs;
	let self = this;

	this.table = createTable(e.tblujian, {
		title: "",
		language: {
			zeroRecords: "Tidak ada ujian."
		},
        scrollX: true,
		selectedRowClass: '',
		roles: ["read"],
		ajax: "/siswa/ujian/ujian_list_event",
		searching: true,
		paramData: function(d) {
			d.paket_id = self.$route.params.id;
			d.type = self.$route.params.type;
		},
		columns: [
			{ data: "ujian_title" },
			{ data: "durasi",
			render: function (data, type, row, meta) {
				return `<h5>`+data+` Menit</h5>`;
			}, },
			{ data: "total_soal",
			render: function (data, type, row, meta) {
				return `<h5>${data} Soal</h5>`;
			}, },
			{ data: "total_ujian",
			render: function (data, type, row, meta) {
				var total = data && data != null && data != 'null' ? data : 0
				if (self.$route.params.type == 'latihan') {
					return `<h6>${total}x dari 1x percobaan</h6>`;
				} else {
					return `<h6>${total}x dari 1x pengerjaan</h6>`;
				}
			}, },
			{ data: "action",
			sortable: false,
			render: function (data, type, row, meta) {
				// Check localStorage for simbol aritmatika session (Lanjutkan)
				if (row.mapel_id == 40) {
					try {
						var sessionRaw = localStorage.getItem('simbol_session_' + row.ujian_code);
						if (sessionRaw) {
							var session = JSON.parse(sessionRaw);
							if (session.hasil_id && session.colStartTime) {
								var elapsed = Math.floor(Date.now() / 1000) - session.colStartTime;
								var totalDurasi = (session.colTimerDuration || 180) * (session.total_col || 1);
								if (elapsed < totalDurasi) {
									var terjawab = session.all_soal ? session.all_soal.filter(function(s) { return s.is_answered; }).length : 0;
									return `<div class="btn-group"><button type="button" class="btn btn-sm btn-warning" data-action="continue" data-id="`+row.ujian_code+`"><i class="fas fa-play"></i> Lanjutkan (`+terjawab+`/`+session.total_soal+`)</button></div>`;
								}
							}
						}
					} catch(e) {}
				}

				// Lanjutkan pengerjaan jika belum selesai dan belum expired
				if (row.finished_on == null && row.expired === false) {
					return `<div class="btn-group"><button type="button" class="btn btn-sm btn-info" data-action="view" data-id="`+row.ujian_code+`"><i class="fas fa-edit"></i> Lanjutkan</button></div>`;
				}

				// Psikotes (Kecermatan & Simbol Aritmatika)
				if (row.mapel_id == 34 || row.mapel_id == 40) {
					var actionRekap = row.mapel_id == 40 ? 'rekap-simbol' : 'rekap-kecermatan';
					if (row.total_ujian >= 1) {
						var btns = `<button type="button" class="btn btn-sm btn-success" data-action="` + actionRekap + `" data-id="` + row.ujian_code + `"> Rekap Hasil</button>`;
						if (self.$route.params.type == 'ujian') {
							btns += ` <button type="button" class="btn btn-sm btn-primary" data-action="rank" data-id="` + row.ujian_code + `" data-mapelid="` + row.mapel_id + `">Ranking List</button>`;
						}
						return btns;
					}
				}

				if (self.$route.params.type == 'ujian') {
					if (row.total_ujian >= 1) {
					return `
					<button style="margin-bottom:8px" type="button" class="btn btn-sm btn-success" data-action="view" data-id="` + row.ujian_code + `"> Pembahasan </button>
					<button style="margin-bottom:8px" type="button" class="btn btn-sm btn-primary" data-action="rank" data-id="` + row.ujian_code + `" data-mapelid="` + row.mapel_id + `">Ranking List</button>`;
					}
					
					if (row.total_ujian > 0) {
					return `
					<button style="margin-bottom:8px" type="button" class="btn btn-sm btn-info" data-action="view" data-id="` + row.ujian_code + `"> Mulai </button>
					<button style="margin-bottom:8px" type="button" class="btn btn-sm btn-primary" data-action="rank" data-id="` + row.ujian_code + `" data-mapelid="` + row.mapel_id + `">Ranking List</button>`;
					}
				}

				if (self.$route.params.type == 'latihan') {
					if (row.total_ujian >= 1) {
					return `<button type="button" class="btn btn-sm btn-success" data-action="view" data-id="` + row.ujian_code + `"><i class="fas fa-eye"></i> Pembahasan </button>`;
					}
					
					if (row.total_ujian > 0) {
					return `<div class="btn-group"><button type="button" class="btn btn-sm btn-info" data-action="view" data-id="`+row.ujian_code+`"><i class="fas fa-edit"></i> Mulai</button></div>`;
					}
				}

				if (row.total_ujian < 1) {
                    if (row.total_soal < 1) {
                        return 'Belum Ada Soal.';
                    } else {
                        return `<div class="btn-group"><button type="button" class="btn btn-sm btn-info" data-action="view" data-id="`+row.ujian_code+`"><i class="fas fa-edit"></i> Mulai</button></div>`;
                    }
				}
			}, },
		],
		filter: false
		// filterBy: [0],
	});
    },
}
</script>
<style type="text/css" scoped>
</style>